var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{on:{"click":_vm.create}},[_c('v-list-item-action',[_c('v-icon',[_vm._v("mdi-bank-plus")])],1),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Create New Business")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }